import common from './common';
import performance from './performance';
import config from './config';
import event from './event';
import user from './user';
import topologymap from './topologymap';
import dashboard from './dashboard';
import socket from './socket';
import router from './router';
import action from './action';
import setting from './setting';
import tree from './tree';
import smartAnalyzer from './smart-analyzer';
import ams from './ams';
import popup from './popup';
import chartAnalysis from './chart-analysis';
import apm from './apm';
// import permission from './permission';

export default {
  common,
  performance,
  config,
  event,
  user,
  topologymap,
  dashboard,
  socket,
  router,
  action,
  setting,
  tree,
  smartAnalyzer,
  ams,
  apm,
  popup,
  chartAnalysis,
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js